<div class="p-4 md:p-8 bg-green-50 min-h-screen font-sans">

  <div class="max-w-6xl mx-auto mb-4">
    <button (click)="goBack()" class="flex items-center gap-2 text-green-600 hover:text-green-800 transition-all group">
      <i class="fas fa-arrow-left transition-transform group-hover:-translate-x-1"></i>
      <span class="text-[10px] font-black uppercase tracking-[0.2em]">Back to Dashboard</span>
    </button>
  </div>
  
  <!-- Header Section -->
  <div class="max-w-6xl mx-auto mb-8">
    <div class="flex items-center gap-3">
      <!-- <div class="w-2 h-8 bg-green-500 rounded-full"></div> -->
      <h1 class="text-2xl font-black text-green-800 tracking-tight uppercase"><i class="fab fa-whatsapp"></i> WhatsApp API Panel</h1>
    </div>
    <p class="text-green-500 text-sm ml-5">Manage your WhatsApp instances and device linking</p>
  </div>

  <div class="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">

    <!-- LEFT PANEL: Instance Management -->
    <div class="bg-white border border-green-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
      <div class="bg-green-800 py-4 px-6">
        <h2 class="text-white font-bold text-sm uppercase tracking-widest flex items-center gap-2">
          <span class="relative flex h-3 w-3">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
            <span class="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
          </span>
          Instance Control
        </h2>
      </div>

      <div class="p-6 md:p-10 flex-1 flex items-center justify-center min-h-[400px]">
        @if (isLoading) {
          <div class="flex flex-col items-center gap-4">
            <div class="w-12 h-12 border-4 border-blue-100 border-t-blue-600 rounded-full animate-spin"></div>
            <span class="text-sm font-bold text-green-400 uppercase tracking-widest">Processing...</span>
          </div>
        } 
        
        @else if (!isInstanceCreated) {
          <div class="text-center">
            <div class="mb-6 opacity-20">
              <i class="fas fa-server text-6xl text-green-400"></i>
            </div>
            <button
              (click)="startInstance()"
              class="bg-blue-600 text-white px-8 py-3 rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 active:scale-95 w-full sm:w-auto">
              START NEW INSTANCE
            </button>
          </div>
        } 
        
        @else {
          <div class="w-full text-center">
            <div class="bg-green-50 text-green-700 p-4 rounded-xl border border-green-100 mb-8">
              <p class="text-sm font-bold uppercase mb-1">Status: Active</p>
              <p class="font-mono text-xs opacity-70">ID: {{ instanceId }}</p>
            </div>
          
            <div class="grid grid-cols-2 gap-4 mb-8">
              <button
                (click)="restartInstance()"
                class="bg-amber-50 text-amber-600 border border-amber-200 py-3 rounded-xl font-bold hover:bg-amber-100 transition-all flex items-center justify-center gap-2">
                <i class="fas fa-sync-alt"></i> RESTART
              </button>
            
              <button
                (click)="terminateInstance()"
                class="bg-red-50 text-red-600 border border-red-200 py-3 rounded-xl font-bold hover:bg-red-100 transition-all flex items-center justify-center gap-2">
                <i class="fas fa-power-off"></i> TERMINATE
              </button>
            </div>
          
            <!-- Test Message Section -->
            <div class="bg-green-50 p-6 rounded-2xl border border-green-100">
              <h3 class="text-xs font-black text-black-400 uppercase tracking-widest mb-4">Send Test Connection</h3>
              <div class="flex flex-col gap-3">
                <input
                  type="text"
                  placeholder="WhatsApp number (e.g. 91...)"
                  [(ngModel)]="testPhoneNumber"
                  class="border border-green-200 px-4 py-3 rounded-xl w-full text-center focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                />
                <button
                  (click)="sendTestMessage()"
                  [disabled]="!testPhoneNumber"
                  class="bg-green-800 text-white px-6 py-3 rounded-xl font-bold disabled:opacity-30 transition-all hover:bg-black active:scale-95">
                  SEND TEST MESSAGE
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- RIGHT PANEL: QR Code Scan -->
    <div class="bg-white border border-green-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">
      <div class="bg-green-800 py-4 px-6 text-center lg:text-left">
        <h2 class="text-white font-bold text-sm uppercase tracking-widest flex items-center justify-center lg:justify-start gap-2">
          <i class="fas fa-qrcode text-green-400"></i>
          Link Device (Scan QR)
        </h2>
      </div>

      <div class="p-6 md:p-10 flex-1 flex items-center justify-center min-h-[400px]">
        @if (!isInstanceCreated) {
          <div class="text-center px-6">
            <i class="fas fa-lock text-green-200 text-5xl mb-4"></i>
            <p class="text-green-400 font-medium italic">Please create an instance first to generate a secure QR code.</p>
          </div>
        } 
        
        @else if (isLoading) {
          <div class="flex flex-col items-center gap-4">
            <div class="w-12 h-12 border-4 border-green-100 border-t-green-500 rounded-full animate-spin"></div>
            <span class="text-sm font-bold text-green-400 uppercase tracking-widest">Generating QR Code...</span>
          </div>
        } 
        
        @else {
          <div class="flex flex-col items-center w-full">
            <div class="bg-white p-4 rounded-2xl border-2 border-green-100 shadow-inner mb-6 transition-all hover:shadow-lg">
              <img [src]="qrCodeUrl" class="max-w-full h-auto w-48 sm:w-64" alt="QR Code">
            </div>

            <button (click)="refreshQr()"
              class="bg-white border border-green-200 text-green-600 px-8 py-2.5 rounded-xl font-bold text-sm hover:bg-green-50 transition-all active:scale-95 flex items-center gap-2">
              <i class="fas fa-redo-alt"></i> REFRESH QR
            </button>
            
            <p class="mt-6 text-[10px] text-black-400 uppercase font-black tracking-[0.2em] text-center">
              Open WhatsApp > Linked Devices > Link a Device
            </p>
          </div>
        }
      </div>
    </div>

  </div>
</div>